import { ErrorPanel } from "@qubit/autoparts";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "~/app/store";

import MultiPort from "~/features/autostoreBin/MultiPort";

import { mixpanelTrack, useMixpanelPageName } from "~/lib/mixpanel-tracking";
import { selectNextBinInventoryByPort } from "~/redux/selectors/autostoreSelectors";
import {
  selectMultiportSelectedCompartment,
  selectSelectedSummaries
} from "~/redux/selectors/inventorySelectors";
import {
  selectNextEmptyBinByPort,
  selectThisWorkstation,
  selectIsShortSideBin
} from "~/redux/selectors/workstationsSelectors";

import {
  setIsInventoryAdjustDialogOpen,
  setSelectedAdjustingSummary
} from "./inventory.slice";

export function InventoryMultiPort() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const trackedPageName = useMixpanelPageName();
  const isShortSideBin = useAppSelector(selectIsShortSideBin);
  const currentSelectedBinNumber = useAppSelector(
    (state) => state.inventoryNew.selectedAdjustingSummary?.autostoreBinNumber
  );
  const nextBinInventoryByPort = useAppSelector(selectNextBinInventoryByPort);
  const nextEmptyBinByPort = useAppSelector(selectNextEmptyBinByPort);
  const siteWorkstation = useAppSelector(selectThisWorkstation);
  const selectedCompartment = useAppSelector(
    selectMultiportSelectedCompartment
  );
  const selectedSummaries = useAppSelector(selectSelectedSummaries);

  return siteWorkstation ? (
    <MultiPort
      pickQuantity={0}
      nextBinInventoryByPort={nextBinInventoryByPort}
      nextEmptyBinByPort={nextEmptyBinByPort}
      workstation={siteWorkstation}
      currentSelectedBinId={currentSelectedBinNumber}
      selectedCompartment={selectedCompartment}
      onBinClick={(compartment, binId) => {
        const selectedCompartment = (compartment || 0) + 1;
        const matchingSummariesByBin = selectedSummaries.filter(
          (row) => row.autostoreBinNumber === binId
        );
        const matchingSummaryByCompartment = matchingSummariesByBin.find(
          (summary) =>
            summary.autostoreCompartmentNumber === selectedCompartment
        );
        if (matchingSummariesByBin.length) {
          dispatch(
            setSelectedAdjustingSummary(
              matchingSummaryByCompartment || matchingSummariesByBin[0]
            )
          );
          dispatch(setIsInventoryAdjustDialogOpen(true));
          mixpanelTrack({
            trackedPageName,
            type: "Select Row",
            label: "Select Inventory Compartment To Adjust",
            eventProperties:
              matchingSummaryByCompartment || matchingSummariesByBin[0]
          });
        }
      }}
      isShortSideBin={isShortSideBin}
    />
  ) : (
    <ErrorPanel message={t("no autostore port selected")} flex="1 1 100%" />
  );
}
